import { render, staticRenderFns } from "./parentQues.vue?vue&type=template&id=52444f70&scoped=true"
import script from "./parentQues.vue?vue&type=script&lang=js"
export * from "./parentQues.vue?vue&type=script&lang=js"
import style0 from "./parentQues.vue?vue&type=style&index=0&id=52444f70&prod&scoped=true&lang=less"
import style1 from "./parentQues.vue?vue&type=style&index=1&id=52444f70&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52444f70",
  null
  
)

export default component.exports